import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Dropdown, DropdownMenu, DropdownToggle, DropdownItem} from 'reactstrap';
import LoadingProgress from '../../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';



class InternetCheck extends ReactQueryParams {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            items: [
                {key: "https://did.li/cellcom", value: "בדיקת תשתית סיבים סלקום"},
                {key: "https://did.li/partner1", value: "בדיקת תשתית סיבים פרטנר"},
                {key: "https://did.li/bezeq11", value: "בדיקת תשתית סיבים בזק"},
                {key: "https://did.li/HOT-net", value: "בדיקת תשתית סיבים הוט"},
                {key: "https://did.li/unlimited", value: "בדיקת תשתית סיבים אולטימייד"}],
            loading: false
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    render() {

        let title = 'בדיקת תשתית סיבים';

        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle
                    className="icon icon--right btn btn-outline-primary btn-sm"
                    tag="span"
                    onClick={this.toggle}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen}
                >
                    <p>
                        {title}
                        <svg width="24" height="24" viewBox="0 0 24 24" className="mdi-icon">
                            <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                        </svg>
                    </p>

                </DropdownToggle>
                <DropdownMenu className='dropdown__menu'>
                    {this.state.loading &&
                    <DropdownItem>
                        <LoadingProgress></LoadingProgress>
                    </DropdownItem>
                    }

                    {!this.state.loading &&
                    this.state.items.map((currItem, index) =>
                        <DropdownItem key={index} onClick={(e) => {
                            e.preventDefault();
                            window.open(currItem.key, '_blank');
                        }}>
                            {currItem.value}
                        </DropdownItem>
                    )
                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        //date: state.mainDashboard.date
    };
};

export default withRouter(connect(mapStateToProps)(InternetCheck))
